import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  root: {
    padding: '30px 45px',
    marginTop: '30px',
  },
  wrapperBlocks: {
    flexWrap: 'nowrap',
  },
  overallPlanDescription: {
    marginRight: 60,
  },
  planText: {
    '& h2': {
      fontWeight: 500,
      margin: [[10, 0]],
    },
  },
  priceText: {
    whiteSpace: 'nowrap',
  },
  planListData: {
    '& .MuiListItem-root': {
      padding: [[5, 0]],
      '& svg': {
        marginRight: 10,
      },
    },
  },
  notAvailable: {
    '& svg': {
      color: '#BF2121',
    },
  },
  button: {
    whiteSpace: 'nowrap',
  },
}));
